export const CARDS_LOGO = {
    VISA: '/img/payments/visa-small.svg',
    MASTERCARD: '/img/payments/mastercard.svg'
}
